/*
 * MARCEL AFTERS — high-resolution artwork on hover.
 *
 * Product cards carry `data-ma-art="<cdn url>"`, written by snippets/ma-artwork.liquid from the
 * product's `design:` tag. This script drops a cross-fading layer over whichever element the
 * theme actually used to render the card image, so it survives Horizon markup changes.
 *
 * On a product page the same treatment is applied to the first media tile in the gallery,
 * driven by `#ma-pdp-art[data-ma-art]` which the product template emits.
 *
 * No dependencies. Idempotent. Re-runs on facet/section morphs.
 */
(function () {
  'use strict';

  var CARD_SELECTOR = 'product-card[data-ma-art]';

  function buildLayer(url, className, alt) {
    var layer = document.createElement('div');
    layer.className = className;
    layer.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.src = url;
    img.alt = alt || '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.addEventListener('error', function () {
      // No artwork published for this design code — remove the layer rather than show a broken tile.
      if (layer.parentNode) layer.parentNode.removeChild(layer);
    });
    layer.appendChild(img);
    return layer;
  }

  /* The element that visually holds the card image. Prefer a real media wrapper; fall back to
     the first image's parent, which is correct for every Horizon card variant we ship. */
  function mediaHost(card) {
    var img = card.querySelector('img');
    if (!img) return null;
    var host =
      img.closest('.product-media-container') ||
      img.closest('.product-media') ||
      img.closest('slideshow-slide') ||
      img.parentElement;
    if (!host || host === card) return null;
    return host;
  }

  function decorateCard(card) {
    if (card.dataset.maArtDone === '1') return;
    var url = card.getAttribute('data-ma-art');
    if (!url) return;
    var host = mediaHost(card);
    if (!host) return;
    card.dataset.maArtDone = '1';
    host.classList.add('ma-art-host');
    host.appendChild(buildLayer(url, 'ma-art-layer', ''));
  }

  function decorateCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) decorateCard(cards[i]);
  }

  function decoratePdp() {
    var data = document.getElementById('ma-pdp-art');
    if (!data || data.dataset.maArtDone === '1') return;
    var url = data.getAttribute('data-ma-art');
    if (!url) return;

    var gallery =
      document.querySelector('.product-media-gallery') ||
      document.querySelector('media-gallery') ||
      document.querySelector('[class*="product-media-container"]');
    if (!gallery) return;

    var img = gallery.querySelector('img');
    if (!img) return;
    var host =
      img.closest('.product-media-container') ||
      img.closest('.product-media') ||
      img.parentElement;
    if (!host) return;

    data.dataset.maArtDone = '1';
    host.classList.add('ma-pdp-art-host');
    var layer = buildLayer(url, 'ma-pdp-art-layer', data.getAttribute('data-ma-alt') || '');
    host.appendChild(layer);

    var hint = document.createElement('span');
    hint.className = 'ma-pdp-art-hint';
    hint.textContent = 'Hover for the artwork';
    host.appendChild(hint);

    // No artwork published for this design code: drop the hint too, so it never promises a hover that does nothing.
    layer.querySelector('img').addEventListener('error', function () {
      if (hint.parentNode) hint.parentNode.removeChild(hint);
      host.classList.remove('ma-pdp-art-host');
    });
  }

  function run(root) {
    decorateCards(root);
    decoratePdp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  /* Horizon morphs the grid in place when facets or pagination change, and swaps the gallery
     on variant change. Watch for new cards instead of rebinding on every theme event name. */
  if (typeof MutationObserver !== 'undefined') {
    /* Perf (4 Oct 2026): was one whole-document sweep per animation frame for as long as nodes kept arriving (page load,
       lazy images, injected chips). The layers are hover-only, so at most one sweep per 100 ms is indistinguishable. */
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        run(document);
      }, 100);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
